import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  field: {
    width: '100%',
    '& label': {
      fontSize: '1.2rem'
    }
  },
  inputFile: {
    width: '100%',
    padding: '1.5rem',
    border: '2px dashed #c6c6c6',
    borderRadius: 4,
    marginTop: '1rem',
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    '&::file-selector-button': {
      marginRight: '1rem'
    }
  },
  legend: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    fontSize: '0.875rem',
    color: theme.palette.text.secondary
  }
}))
